<gx-message
  [messageId]="appMessage?.id"
  [messageText]="appMessage?.text | translate"
  duration="3"
></gx-message>